export class Recruiter {
    public recruiterId: number = 0;
    public recruiterName: string = '';
    public recruiterEmail: string = '';
}
